import React from "react";
import "./index.css";

const Navigation = (props) => {
  return (
    <div className={`menuContainer ${props.mode}`}>
      <div className="navBar">
        <div className="navBarLeft">
          <div className="logo">
            <h1 className={`${props.mode}`}>
              TextEditor
              <a href="/" className={`${props.mode}`}>
                .com
              </a>
            </h1>
          </div>
          <div className="home">
            <h1 className={`${props.mode}`}>Home</h1>
          </div>
        </div>
        <div className="navBarRight">
          <div className="slideSwitch">
            <input
              type="checkbox"
              onClick={props.toggleMode}
              id="slideSwitch"
            />
            <label htmlFor="slideSwitch"></label>
          </div>
          <div className="switchPara">
            <p className={`${props.mode}`}>{`${props.modeType}`}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
